import track from './eventTracker';

const determineEventName = source => {
  return source === 'shop-your-looks'
    ? 'cml.item'
    : 'kept_item_gallery.interaction';
};

const RelatedItemsCarouselEventTracker = {
  trackCarouselSeenInViewport: ({
    collection = '',
    outfitId,
    pdpSkuId = null,
    externalProductId = '',
    referringSkuId = 0,
    referringSkuInStock = false,
    relatedItemsSkuIds,
    source,
    subSource,
    carouselId = 'similar_items',
  }) => {
    const actionName = {
      best_brands: 'brand_carousel_view',
      brand: 'brand_carousel_view',
      similar_items: 'carousel_view',
    }[carouselId];

    return track({
      action_name: actionName,
      action_type: 'view',
      canonical_name: 'pdp',
      collection,
      event_name: determineEventName(source),
      outfit_id: outfitId,
      // TODO: Confirm no one is using pdp_sku_id and remove in favor of sku_id
      pdp_sku_id: pdpSkuId,
      referring_sku_id: referringSkuId,
      referring_sku_in_stock: referringSkuInStock,
      related_item_sku_ids: relatedItemsSkuIds,
      sku_id: pdpSkuId,
      external_product_id: externalProductId,
      source,
      sub_source: subSource,
    });
  },

  trackCarouselScroll: ({
    collectionName = '',
    pdpSkuId = null,
    externalProductId = '',
    referringSkuInStock = false,
    relatedItemIsVisible,
    relatedItemSkuId,
    relatedItemsSkuIds,
    source,
    carouselId = 'similar_items',
  }) => {
    const actionName = {
      best_brands: 'brand_scroll_carousel',
      brand: 'brand_scroll_carousel',
      similar_items: 'scroll_carousel',
    }[carouselId];

    return track({
      action_name: actionName,
      action_type: 'scroll',
      canonical_name: 'pdp',
      collection: collectionName,
      event_name: determineEventName(source),
      // TODO: Confirm no one is using pdp_sku_id and remove in favor of sku_id
      pdp_sku_id: pdpSkuId,
      referring_sku_in_stock: referringSkuInStock,
      related_item_is_visible: relatedItemIsVisible,
      related_item_sku_id: relatedItemSkuId,
      related_item_sku_ids: relatedItemsSkuIds,
      sku_id: pdpSkuId,
      external_product_id: externalProductId,
      source,
    });
  },

  trackCarouselItemClick: ({
    collectionName,
    relatedItemsSkuIds,
    relatedItemSkuId,
    pdpSkuId,
    externalProductId,
    source,
    subSource,
    carouselId = 'similar_items',
  }) => {
    const actionName = {
      best_brands: 'brand_click_carousel_recommended',
      brand: 'brand_click_carousel_recommended',
      similar_items: 'click_carousel_recommended',
    }[carouselId];

    track({
      action_name: actionName,
      action_type: 'click',
      canonical_name: 'pdp',
      collection: collectionName,
      event_name: determineEventName(source),
      sku_id: pdpSkuId,
      external_product_id: externalProductId,
      related_item_sku_ids: relatedItemsSkuIds,
      related_item_sku_id: relatedItemSkuId,
      source,
      sub_source: subSource,
    });
  },

  trackCarouselEndCardClick: ({
    carouselId = 'similar_items',
    collectionName,
    pdpSkuId,
    externalProductId,
    source,
    subSource,
  }) => {
    const actionName = {
      best_brands: 'brand_carousel_end_card',
      brand: 'brand_carousel_end_card',
      similar_items: 'carousel_end_card',
    }[carouselId];

    track({
      action_name: actionName,
      action_type: 'click',
      canonical_name: 'pdp',
      collection: collectionName,
      event_name: determineEventName(source),
      sku_id: pdpSkuId,
      external_product_id: externalProductId,
      source,
      sub_source: subSource,
    });
  },

  trackCarouselEndCardView: ({
    carouselId = 'similar_items',
    collectionName,
    pdpSkuId,
    externalProductId,
    source,
    subSource,
  }) => {
    const actionName = {
      best_brands: 'brand_carousel_end_card',
      brand: 'brand_carousel_end_card',
      similar_items: 'carousel_end_card',
    }[carouselId];

    track({
      action_name: actionName,
      action_type: 'view',
      canonical_name: 'pdp',
      collection: collectionName,
      event_name: determineEventName(source),
      sku_id: pdpSkuId,
      external_product_id: externalProductId,
      source,
      sub_source: subSource,
    });
  },

  trackCarouselViewAllClick: ({
    carouselId = 'similar_items',
    collectionName,
    pdpSkuId,
    externalProductId,
    source,
    subSource,
  }) => {
    const actionName = {
      best_brands: 'brand_carousel_view_all',
      brand: 'brand_carousel_view_all',
      similar_items: 'carousel_view_all',
    }[carouselId];

    track({
      action_name: actionName,
      action_type: 'click',
      canonical_name: 'pdp',
      externalproductId: externalProductId,
      collection: collectionName,
      event_name: determineEventName(source),
      sku_id: pdpSkuId,
      source,
      sub_source: subSource,
    });
  },

  trackCarouselLoadError: ({
    carouselError,
    collectionName,
    pdpSkuId,
    externalProductId,
    source,
    subSource,
  }) => {
    track({
      action_name: `error_carousel_recommended`,
      action_type: `error`,
      canonical_name: 'pdp',
      carousel_error: carouselError,
      collection: collectionName,
      event_name: determineEventName(source),
      sku_id: pdpSkuId,
      external_product_id: externalProductId,
      source,
      sub_source: subSource,
    });
  },
};

export default RelatedItemsCarouselEventTracker;
